<script>
    import TextInput from './TextInput';
    export default {
        mixins: [TextInput],
        data() {
            return {
                inputType: 'password'
            }
        }
    }
</script>